import React from 'react';
import ResetPasswordFrom from './ResetPasswordForm';
import { SuccessError } from './SuccessError';
import { Link } from 'react-router-dom';
import {
  Container, CardHeader, Alert, CardFooter, Row, Col, Card, CardBody
} from 'reactstrap';

import DashboardLogoGroup from '../../components/DashboardLogoGroup';


function refreshPage() { window.parent.location = window.parent.location.href; }


export default class RequestResetPassword extends React.Component {

  render() {

    let { onSubmit, success, error, email } = this.props;

    return (

      <div>
        <Row>
          <DashboardLogoGroup />
        </Row>
        <div className="app flex-row  animated fadeIn  mt-5 pt-5">

          <Container>
            <Row className="justify-content-center">
              <Col md="6">
                {success && !error ?
                  <Alert color="success">
                    <p className="text-center" >{`If the email ${email} is found, you will receive further instruction on how to reset your password.`}</p>

                    <p className="text-center" >
                      You may now <Link onClick={refreshPage} to="/login">refresh</Link> this page, an check you email.
                  </p>
                  </Alert>
                  :
                  <Card>
                    <div>
                      <CardHeader>
                        Request reset password
                  </CardHeader>
                      <CardBody>
                        <ResetPasswordFrom onSubmit={onSubmit} />
                      </CardBody>
                      <CardFooter>

                        <Link to="/login" id="goBack">Go Back to Login</Link>

                      </CardFooter>
                    </div>

                  </Card>
                }
              </Col>
            </Row>
          </Container>
        </div>
      </div>
    );

  }
}


// WEBPACK FOOTER //
// ./src/components/ResetPassword/RequestResetPassword.js